import { Form } from 'antd';
import { t } from 'i18next';
import { memo, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getShipmentDefaultFilters } from '../../../contants/ShipmentEnums';
import { setAppLoader } from '../../../redux/common/CommonActions';
import {
  copyShipmentInProgress,
  getSearchQuoteListInProgress,
  setSearchQuoteFilters,
  setSelectedShipments,
  setShipmentFilters,
  setShipmentList,
} from '../../../redux/shipment/ShipmentActions';
import EmptyRecords from '../../components/Common/EmptyRecords';
import CommonModal from '../../components/Modals/CommonModal';
import Paper from '../../components/Paper/Paper';
import ContentSpinner from '../../components/Spinners/ContentSpinner';
import QuoteList from './QuoteList';
import ShipmentStatusUpdateForm from './components/ShipmentHeader/ShipmentStatusUpdateForm';

const QuoteContent = () => {
  const [statusUpdateModal, setStatusUpdateModal] = useState(false);
  const [selectedShipmentsWithDetails, setSelectedShipmentsWithDetails] = useState([]);
  const dispatch = useDispatch();
  const quoteSearchFilters = useSelector((state) => state.shipment.searchQuoteFilters, shallowEqual);
  const selectedShipments = useSelector((state) => state.shipment.selectedShipments, shallowEqual);
  const quoteSearchList = useSelector((state) => state.shipment.quoteSearchList);
  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);
  const { appLoader } = useSelector((state) => state.common);

  const userId = useSelector((state) => state.auth.user.data.id, shallowEqual);
  const [statusUpdateForm] = Form.useForm();

  const onSelect = (id, remove) => {
    const selectedShipmentsLocal = [...selectedShipments];
    if (!remove) {
      selectedShipmentsLocal.push(id);
    } else {
      const index = selectedShipmentsLocal.indexOf(id);
      selectedShipmentsLocal.splice(index, 1);
    }
    dispatch(setSelectedShipments(selectedShipmentsLocal));
  };

  useEffect(() => {
    if (companyId) {
      dispatch(setSelectedShipments([]));
      dispatch(
        setShipmentFilters({
          ...getShipmentDefaultFilters(),
          PageNumber: 1,
        }),
      );
      dispatch(
        setShipmentList({
          data: [],
          progressing: true,
          isFirstTime: true,
          totalRecords: 0,
          latedelivery: 0,
          latepickup: 0,
          missingDocument: 0,
          pickupFailed: 0,
          trackingfailures: 0,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  const handleLoadMore = () => {
    dispatch(
      setSearchQuoteFilters({
        ...quoteSearchFilters,
      }),
    );
    dispatch(getSearchQuoteListInProgress());
  };

  const totalPageCount = quoteSearchList.success
    ? Math.floor((quoteSearchList?.totalRecords + (quoteSearchFilters.PageSize - 1)) / quoteSearchFilters.PageSize)
    : 0;

  const handleCopy = (shipmentKey, InterNationalTransload) => {
    const { shipmentNo, approvalNumber } =
      quoteSearchList?.data?.find((item) => item.shipmentKey === shipmentKey) || {};
    const payload = {
      oldShipmentNumber: shipmentNo,
      oldApprovalNumber: approvalNumber,
      OldShipmentKey: shipmentKey,
      UserId: userId,
      InterNationalTransload,
    };
    dispatch(setAppLoader(true));
    dispatch(copyShipmentInProgress(payload));
  };

  const handleUpdateStatus = (status) => {
    if (status) {
      setStatusUpdateModal(false);
    }
  };

  const onClickStatusUpdate = (shipmentKey) => {
    let newSelectedShipment = quoteSearchList.data?.filter((item) => item.shipmentKey === shipmentKey);
    newSelectedShipment = newSelectedShipment.map(({ shipmentKey, shipmentNo, status, customerKey }) => ({
      shipmentKey,
      shipmentNumber: shipmentNo,
      fromShipmentStatus: status,
      customerKey,
      userId: userId,
      isDelivered: 0,
    }));
    setSelectedShipmentsWithDetails(newSelectedShipment);
    setStatusUpdateModal(true);
  };

  return (
    <div className="h-100 d-flex flex-direction-column mt-15" data-testid="search-quote-content-table">
      {quoteSearchList.isFirstTime ? (
        <Paper className="h-100 w-100 mb-15" />
      ) : (
        <>
          {quoteSearchList.data && quoteSearchList.data.length > 0 ? (
            <QuoteList
              shipmentList={quoteSearchList.data}
              onSelect={onSelect}
              onClickStatusUpdate={onClickStatusUpdate}
              handleLoadMore={handleLoadMore}
              hasMore={quoteSearchList.progressing ? false : quoteSearchFilters?.PageNumber < totalPageCount}
              selectedShipments={selectedShipments}
              handleCopy={handleCopy}
              isLoading={quoteSearchList.progressing}
            />
          ) : (
            <>
              {quoteSearchList.progressing || appLoader ? (
                <ContentSpinner size="large" />
              ) : (
                <EmptyRecords className="mb-15" />
              )}
            </>
          )}
        </>
      )}
      <CommonModal
        open={statusUpdateModal}
        title={t('translation:shipment.header.commonUpdateModal.title')}
        okText={t('translation:default.buttons.update')}
        cancelText={t('translation:default.buttons.cancel')}
        onCancel={() => setStatusUpdateModal(false)}
        onClose={() => setStatusUpdateModal(false)}
        onOk={() => statusUpdateForm.submit()}
        className="h-50 w-40"
        destroyOnClose
      >
        <ShipmentStatusUpdateForm
          parentFormRef={statusUpdateForm}
          handleUpdateStatus={handleUpdateStatus}
          selectedShipments={selectedShipmentsWithDetails}
        />
      </CommonModal>
    </div>
  );
};

export default memo(QuoteContent);
